import React from 'react';
import { translate } from '../../../utils/translations';
import PropTypes from 'prop-types';
import { SUFFIXES } from '../../../utils/globals';

const { speed } = SUFFIXES;

const WindSpeedInput = props => (
    <div className="form__item">
        <label htmlFor="windSpeedFormat">
            {translate(props.language, 'label_wind_speed_format')}
        </label>
        <select
            name="windSpeedFormat"
            id="windSpeedFormat"
            value={props.windSpeedFormat}
            onChange={props.handleChange}
            className="select-wind-format"
        >
            <option value={speed.km}>
                {translate(props.language, 'label_kmh')}
            </option>
            <option value={speed.knots}>
                {translate(props.language, 'label_knots')}
            </option>
        </select>
    </div>
);

WindSpeedInput.propTypes = {
    language: PropTypes.string,
    windSpeedFormat: PropTypes.string,
    handleChange: PropTypes.func,
};

export default WindSpeedInput;



// WEBPACK FOOTER //
// ./src/containers/Configurador/FormPartials/WindSpeedInput.js